var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 0C4.36837 0 4.91341 0.230468 5.31528 0.640704C5.71714 1.05094 5.94291 1.60734 5.94291 2.1875V3.0625C6.17023 3.0625 6.38825 3.15469 6.549 3.31878C6.70974 3.48288 6.80005 3.70544 6.80005 3.9375V6.125C6.80005 6.35706 6.70974 6.57962 6.549 6.74372C6.38825 6.90781 6.17023 7 5.94291 7H1.65719C1.42986 7 1.21185 6.90781 1.0511 6.74372C0.890355 6.57962 0.800049 6.35706 0.800049 6.125V3.9375C0.800049 3.70544 0.890355 3.48288 1.0511 3.31878C1.21185 3.15469 1.42986 3.0625 1.65719 3.0625H5.08576V2.1875C5.08587 1.86797 4.97179 1.55937 4.76491 1.31958C4.55803 1.07979 4.27256 0.925275 3.96205 0.885015C3.65153 0.844754 3.33729 0.921512 3.07826 1.10089C2.81923 1.28028 2.6332 1.54996 2.55505 1.85938C2.52663 1.97175 2.45565 2.068 2.35772 2.12695C2.30922 2.15614 2.25557 2.1753 2.19983 2.18332C2.14409 2.19134 2.08734 2.18808 2.03283 2.17372C1.97833 2.15936 1.92712 2.13417 1.88215 2.09961C1.83718 2.06505 1.79931 2.02178 1.77072 1.97227C1.74212 1.92277 1.72336 1.86801 1.7155 1.8111C1.70764 1.7542 1.71084 1.69627 1.72491 1.64062C1.84382 1.17108 2.11215 0.755168 2.48776 0.458209C2.86337 0.161251 3.32497 7.54465e-05 3.80005 0Z",
    fill: "#00A5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen1);
export default __webpack_public_path__ + "static/media/lock_open1.c9db0fbdac4dc0e3f4d0a9bf796a061b.svg";
export { ForwardRef as ReactComponent };